import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import CoorpLayout, { Title, Text } from '@/components/layout/CoorpLayout';
import { orderBy } from 'lodash-es';

export default function CareersPage() {
  const { t } = useTranslation();
  const aws_s3_jobs_url = 'https://gindumac-p2p.s3.amazonaws.com/jobs/';
  const careersItems = [
    {
      title: 'Logistics area Manager (Barcelona Office)',
      link: 'Logistics+area+manager+-+Barcelona.pdf',
    },
    {
      title: 'Sales Agent / Machinery Broker – Sweden',
      link: 'Sales%20Agent%20-%20Sweden.pdf',
    },
    {
      title: 'International Procurement & Sales Manager',
      link: 'GINDUMAC-International-Procurement-Sales-Manager.pdf',
    },
    {
      title: 'Content Publishing Intern (Barcelona Office)',
      link: 'Content_Publishing_Intern_-_GINDUMAC.pdf',
    },
    {
      title: 'Export Support Manager (Barcelona Office)',
      link: 'Export-Support-Manager_EN.PDF',
    },
    {
      title: 'Sales Agent / Machinery Broker - Germany',
      link: 'Sales%20Agent%20-%20Machinery%20Broker%20-%20Deutschland.pdf',
    },
    {
      title: 'Sales Agent / Machinery Broker - Switzerland',
      link: 'Sales%20Agent%20-%20Machinery%20Broker%20-%20Schweiz.pdf',
    },
    {
      title: 'Sales Agent / Machinery Broker - Netherlands',
      link: 'Sales+Agent+-+Machinery+Broker+-+Netherlands+-+GINDUMAC.pdf',
    },
    {
      title: 'Sales Agent / Machinery Broker -  UK',
      link: 'Sales+Agent+-+Machinery+Broker+-+UK+-+GINDUMAC.pdf',
    },
    {
      title: 'Front-End Development Intern MIS (Barcelona Office)',
      link: 'Front-end%20Development%20Intern%20-%20MIS.pdf',
    },
    {
      title: 'Market Intelligence Intern (Barcelona Office)',
      link: 'Market%20Intelligence%20Intern.pdf',
    },
    {
      title: 'Web/Graphic Design Intern (Barcelona Office)',
      link: 'Web-Graphic_Design_Intern_-_Barcelona_Office_-_GINDUMAC.pdf',
    },
    {
      title: 'Account Manager - Germany (Barcelona Office)',
      link: 'Account_Manager-Germany(Barcelona_Office)-GINDUMAC.pdf',
    },
    {
      title: 'Account Manager - Italy (Barcelona Office)',
      link: 'Account_Manager-Italy(Barcelona_Office)-GINDUMAC.pdf',
    },
  ];
  // careersItems but order by title alphabetically with lodash
  const careersItemsOrder = orderBy(careersItems, ['title'], ['asc']);

  return (
    <CoorpLayout
      headingOne={t('products:CAREERS_LIST_HEADER_1')}
      headingTwo={t('products:CAREERS_LIST_HEADER_2')}
      headingThree={t('products:CAREERS_LIST_HEADER_3')}
      breadcrubPages={[
        { name: t('products:CAREERS_LIST_HEADER_1'), href: '/careers' },
      ]}
    >
      <Title title={t('products:CAREERS_LIST_HEADER_1')} />
      <Text text={t('products:CAREERS_P1')} />
      <div className='py-8 lg:px-60'>
        {careersItemsOrder.map((career, index) => {
          return (
            <div key={index} className='grid grid-cols-3 gap-4 py-4 text-sm'>
              <p className='col-span-2 text-[#4d4d4d]'>{career.title} </p>
              <a
                href={aws_s3_jobs_url + career.link}
                className='grid justify-end text-[#039be5]'
              >
                {t('products:JOB_OPEN_LINK')}
              </a>
            </div>
          );
        })}
      </div>
    </CoorpLayout>
  );
}
